import styled from 'styled-components';
import media from '../../components/base/media';

export const Wrapper = styled.div`
	margin: 0 auto;
	max-width: 1920px;
	padding-top: ${props => props.theme.header.headerHeightMobile};

	${media.desktopSmall`
		margin-bottom: 10rem;
		padding-top: ${props => props.theme.header.headerHeightDesktop};
	`}

	${media.desktopLarge`
		margin-bottom: 20rem;
	`};
`;
